import { createSlice } from "@reduxjs/toolkit";

export const cms = createSlice({
  name: "cms",
  initialState: {
    isLoading:false,
    getcms: {},
  },
  reducers: {
    onGetcms: (state) => {
      return {
        isLoading:true,
        getcms: {},
      };
    },
    onGetcmsSuccess: (state, { payload }) => {
      const { data = {}, message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading:false,
        getcms: data,
        message,
        status_code,
      };
    },
    onGetcmsError: (state, { payload }) => {
      const { data = {}, message = "", status_code = 400 } = payload;
      return {
        ...state,
        isLoading:false,
        getcms: data,
        message,
        status_code,
      };
    },
    OnGetcmsReset: (state) => {
      return {
        ...state,
        isLoading:false,
        getcms: {},
        message: "",
        status_code: null,
      };
    },
  },
});

export const {
  onGetcms,
  onGetcmsSuccess,
  onGetcmsError,
  OnGetcmsReset,
} = cms.actions;

export default cms.reducer;
